import { ChangeEvent, useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import { deleteFile } from "../../auth/authSlice";
import Delete from "@mui/icons-material/Delete";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Fab from "@mui/material/Fab";
import Badge from "@mui/material/Badge";
import Paper from "@mui/material/Paper";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import Box from "@mui/material/Box";
import Toast from "../../../components/Layout/Toast";
import { PhotoTypes } from "../types/processTypes";
import { selectProcesses, uploadPicture } from "../processSlices";
import { resizeFile } from "../../../utils/imageUtility";
import { Photo } from "@mui/icons-material";
import { Typography } from "@mui/material";

function PassportScan() {
  const [image, setImage] = useState("");

  const {
    selectedEmployee,
    success,
    loading: loadingPassportScan,
    error,
  } = useAppSelector(selectProcesses);
  const dispatch = useAppDispatch();
  const onChangeStand = async (event: ChangeEvent<HTMLInputElement>) => {
    const { validity, files } = event.target;

    if (validity.valid && files && files[0]) {
      const image = (await resizeFile(files[0], 700, 700)) as File;
      if (image) {
        dispatch(
          uploadPicture({
            _id: selectedEmployee!._id as string,
            type: PhotoTypes.Passport,
            avatar: image,
          })
        );
      }
    }
  };

  const removeImage = () => {
    setImage("");
    dispatch(deleteFile(selectedEmployee?.standPhoto as string));
  };

  useEffect(() => {
    if (loadingPassportScan === "pending") {
      document.body.style.opacity = "0.5";
    } else {
      document.body.style.opacity = "1";
    }
  }, [loadingPassportScan]);

  return (
    <>
      <Paper
        elevation={0}
        style={{
          position: "relative",
          borderRadius: 18,
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <input
          name="standImage"
          accept="image/*"
          onChange={onChangeStand}
          style={{ display: "none" }}
          id="icon-button-file-passport"
          type="file"
        />
        <label htmlFor="icon-button-file-passport">
          <>
            <Badge
              overlap="rectangular"
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              badgeContent={
                <Tooltip
                  title="Add/Change Passport Scan"
                  aria-label="icon-button-file-passport"
                >
                  <Fab component="span" color="primary">
                    <IconButton
                      aria-label="icon-button-file-passport"
                      component="span"
                      size="large"
                      color="inherit"
                    >
                      <Photo />
                    </IconButton>
                  </Fab>
                </Tooltip>
              }
            >
              <Avatar
                alt="avatar"
                variant="rounded"
                src={
                  image
                    ? image
                    : selectedEmployee
                    ? selectedEmployee.passportScan
                    : "Passport Scan"
                }
                sx={{
                  height: "600px",
                  width: "300px",
                }}
              >
                <Typography variant="h5" sx={{ px: 10, py: 40 }}>
                  {`Add Passport Scan`}
                </Typography>
              </Avatar>
              {/* {loadingPassportScan === "pending" ? (
                <AuthSkeleton />
              ) : (
              )} */}
            </Badge>
          </>
        </label>{" "}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            marginTop: 0,
          }}
        >
          {(image || (selectedEmployee && selectedEmployee.passportScan)) && (
            <>
              <Box component="div">
                <Tooltip
                  title="Remove Photo"
                  aria-label="icon-button-file-passport"
                >
                  <Fab component="span" color="primary">
                    <IconButton
                      color="inherit"
                      edge="start"
                      onClick={removeImage}
                      size="large"
                      sx={{
                        margin: "auto",
                        width: "auto",
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Fab>
                </Tooltip>
              </Box>
            </>
          )}
        </div>
        <Box m={1}>
          {error && <Toast severity="error">{error.message}</Toast>}
          {success && <Toast severity="success">{success.message}</Toast>}
        </Box>
      </Paper>
    </>
  );
}

export default PassportScan;
